import React, { Fragment } from 'react';
import "./index.css";
import InboxContainer from "./Inbox";
import "./assets/css/index.css";
import { UsersProvider } from "./context/usersContext";
import { SocketProvider } from "./context/socketContext";
import Common from "../../Common/Common";
import { isMobile } from '../../Common/Appcommon';
import ProvidersWrapper from './context/ProvidersWrapper';
import { SSEProvider } from './context/SSEProvider';
class SocketWrapper extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount = async () => {
        
    };

    render() {
        return (
            <SocketProvider>
                <UsersProvider>
                    {isMobile() ? <InboxContainer /> : <Common pageTitle={"Inbox"} mainContent={
                        <InboxContainer />
                    } />}

                </UsersProvider>
            </SocketProvider>
        )
    }

}

export default SocketWrapper;
